//frontend/src/admin/BannerManagement.js
import React, { useState, useEffect } from 'react';
import { FaPlus, FaEdit, FaTrash, FaSave, FaTimes, FaImage, FaUpload, FaClock } from 'react-icons/fa';
import axiosInstance from '../axios';
import '../styles/admin.css';

const BannerManagement = () => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editingBanner, setEditingBanner] = useState(null);
  const [formData, setFormData] = useState({
    title: '',
    subtitle: '',
    description: '',
    background_image: '',
    background_color: '',
    button_text: 'Ачаа хайх',
    display_order: 0,
    is_active: true,
    transition_duration: 5000
  });
  const [imageUploading, setImageUploading] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);

  useEffect(() => {
    fetchBanners();
  }, []);

  const fetchBanners = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get('/api/hero-banners');
      if (response.data.success) {
        setBanners(response.data.data || []);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handleImageUpload = async (file) => {
    if (!file) return;
    setImageUploading(true);
    try {
      const uploadFormData = new FormData();
      uploadFormData.append('image', file);
      const response = await axiosInstance.post('/api/upload-image', uploadFormData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      if (response.data.success) {
        setFormData(prev => ({ ...prev, background_image: response.data.imageUrl }));
        setImagePreview(response.data.imageUrl);
      } else {
        alert(response.data.msg || 'Зураг хуулахад алдаа гарлаа');
      }
    } catch (error) {
      alert('Зураг хуулахад алдаа гарлаа');
    } finally {
      setImageUploading(false);
    }
  };

  const handleImageDelete = async () => {
    if (!formData.background_image) return;
    try {
      await axiosInstance.delete('/api/delete-image', {
        data: { imageUrl: formData.background_image }
      });
      setFormData(prev => ({ ...prev, background_image: '' }));
      setImagePreview(null);
    } catch (error) {
      alert('Зураг устгахад алдаа гарлаа');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      if (editingBanner) {
        await axiosInstance.put(`/api/hero-banners/${editingBanner.id}`, formData);
        alert('Баннер амжилттай шинэчлэгдлээ');
      } else {
        await axiosInstance.post('/api/hero-banners', formData);
        alert('Баннер амжилттай үүсгэгдлээ');
      }
      
      setShowModal(false);
      resetForm();
      fetchBanners();
    } catch (error) {
      alert(error.response?.data?.msg || 'Алдаа гарлаа');
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (banner) => {
    setEditingBanner(banner);
    setFormData({
      title: banner.title,
      subtitle: banner.subtitle || '',
      description: banner.description || '',
      background_image: banner.background_image || '',
      background_color: banner.background_color || '',
      button_text: banner.button_text || 'Ачаа хайх',
      display_order: banner.display_order || 0,
      is_active: banner.is_active,
      transition_duration: banner.transition_duration || 5000
    });
    setImagePreview(banner.background_image || null);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Баннер устгахдаа итгэлтэй байна уу?')) return;
    
    try {
      await axiosInstance.delete(`/api/hero-banners/${id}`);
      alert('Баннер амжилттай устгагдлаа');
      fetchBanners();
    } catch (error) {
      alert(error.response?.data?.msg || 'Устгахад алдаа гарлаа');
    }
  };

  const resetForm = () => {
    setEditingBanner(null);
    setFormData({
      title: '',
      subtitle: '',
      description: '',
      background_image: '',
      background_color: '',
      button_text: 'Ачаа хайх',
      display_order: 0,
      is_active: true,
      transition_duration: 5000
    });
    setImagePreview(null);
  };

  const formatDuration = (ms) => {
    return `${(ms / 1000).toFixed(1)}с`;
  };

  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-6">
      <div className="mb-6 flex justify-between items-center">
        <div>
          <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2 flex items-center">
            <FaImage className="mr-3 text-purple-600" />
            Баннер удирдлага
          </h1>
          <p className="text-sm text-gray-600">Нүүр хуудасны Hero баннер засах</p>
        </div>
        <button
          onClick={() => {
            resetForm();
            setShowModal(true);
          }}
          className="custom-button flex items-center space-x-2 px-6 py-3"
        >
          <FaPlus className="w-4 h-4" />
          <span>Шинэ баннер</span>
        </button>
      </div>

      <div className="table-container bg-white rounded-lg shadow">
        <div className="table-header px-4 py-3 border-b">
          <h2 className="table-title">Баннеруудын жагсаалт</h2>
        </div>
        <div className="overflow-x-auto">
          <table className="data-table w-full">
            <thead>
              <tr>
                <th className="px-4 py-3">Дараалал</th>
                <th className="px-4 py-3">Гарчиг</th>
                <th className="px-4 py-3">Дэд гарчиг</th>
                <th className="px-4 py-3">Товчны текст</th>
                <th className="px-4 py-3">Солигдох хугацаа</th>
                <th className="px-4 py-3">Төлөв</th>
                <th className="px-4 py-3">Үйлдэл</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="7" className="text-center py-8">
                    <div className="loading-spinner mx-auto"></div>
                  </td>
                </tr>
              ) : banners.length === 0 ? (
                <tr>
                  <td colSpan="7" className="text-center py-8 text-gray-500">
                    Баннер байхгүй
                  </td>
                </tr>
              ) : (
                banners.map((banner) => (
                  <tr key={banner.id} className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-center font-bold">{banner.display_order}</td>
                    <td className="px-4 py-3 font-semibold">{banner.title}</td>
                    <td className="px-4 py-3">{banner.subtitle || '-'}</td>
                    <td className="px-4 py-3">{banner.button_text || '-'}</td>
                    <td className="px-4 py-3 text-center">
                      <span className="inline-flex items-center gap-1 text-sm text-gray-600">
                        <FaClock className="text-xs" />
                        {formatDuration(banner.transition_duration || 5000)}
                      </span>
                    </td>
                    <td className="px-4 py-3">
                      {banner.is_active ? (
                        <span className="badge badge-success">Идэвхтэй</span>
                      ) : (
                        <span className="badge badge-secondary">Идэвхгүй</span>
                      )}
                    </td>
                    <td className="px-4 py-3">
                      <div className="flex space-x-2">
                        <button
                          className="icon-button text-blue-600"
                          title="Засах"
                          onClick={() => handleEdit(banner)}
                        >
                          <FaEdit />
                        </button>
                        <button
                          className="icon-button text-red-600"
                          title="Устгах"
                          onClick={() => handleDelete(banner.id)}
                        >
                          <FaTrash />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content max-w-2xl">
            <div className="modal-header">
              <h3 className="text-xl font-bold text-gray-800">
                {editingBanner ? 'Баннер засах' : 'Шинэ баннер'}
              </h3>
              <button onClick={() => { setShowModal(false); resetForm(); }} className="icon-button">
                <FaTimes />
              </button>
            </div>

            <div className="modal-body">
              <form onSubmit={handleSubmit}>
                <div className="space-y-4">
                  <div className="form-group">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Гарчиг <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      className="custom-input"
                      value={formData.title}
                      onChange={(e) => setFormData({...formData, title: e.target.value})}
                      required
                      placeholder="Жишээ: АЧАА ТЭЭВРИЙН ПЛАТФОРМ"
                    />
                  </div>

                  <div className="form-group">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Дэд гарчиг
                    </label>
                    <input
                      type="text"
                      className="custom-input"
                      value={formData.subtitle}
                      onChange={(e) => setFormData({...formData, subtitle: e.target.value})}
                      placeholder="Жишээ: Найдвартай, хурдан хүргэлт"
                    />
                  </div>

                  <div className="form-group">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Тайлбар
                    </label>
                    <textarea
                      className="custom-input"
                      rows="3"
                      value={formData.description}
                      onChange={(e) => setFormData({...formData, description: e.target.value})}
                      placeholder="Жишээ: Олон улсын ачаа тээврийн цогц үйлчилгээ"
                    />
                  </div>

                  <div className="form-group">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Арын өнгө (hex код)
                    </label>
                    <div className="flex gap-2 items-center">
                      <input
                        type="text"
                        className="custom-input flex-1"
                        value={formData.background_color}
                        onChange={(e) => setFormData({...formData, background_color: e.target.value})}
                        placeholder="#4f46e5 эсвэл linear-gradient(...)"
                      />
                      {formData.background_color && !formData.background_color.includes('gradient') && (
                        <div 
                          className="w-12 h-12 rounded-lg border-2 border-gray-300"
                          style={{ backgroundColor: formData.background_color }}
                        ></div>
                      )}
                    </div>
                    <p className="text-xs text-gray-500 mt-1">
                      Жишээ: #ffffff эсвэл linear-gradient(135deg, #667eea 0%, #764ba2 100%)
                    </p>
                  </div>

                  <div className="form-group">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Арын зураг
                    </label>
                    {imagePreview && (
                      <div className="mb-4 relative">
                        <img 
                          src={imagePreview} 
                          alt="Banner preview" 
                          className="w-full h-48 object-cover rounded-lg shadow"
                        />
                        <button
                          type="button"
                          onClick={handleImageDelete}
                          className="absolute top-2 right-2 bg-red-600 text-white p-2 rounded-full hover:bg-red-700 transition"
                        >
                          <FaTimes className="w-4 h-4" />
                        </button>
                      </div>
                    )}
                    <label className="custom-file-upload flex items-center justify-center">
                      <input 
                        type="file" 
                        accept="image/jpeg,image/jpg,image/png,image/gif,image/webp" 
                        onChange={(e) => handleImageUpload(e.target.files[0])}
                        disabled={imageUploading || loading}
                      />
                      <FaUpload className="mr-2" />
                      {imageUploading ? 'Хуулж байна...' : 'Зураг сонгох'}
                    </label>
                    <p className="text-xs text-gray-500 mt-1">
                      Зөвхөн jpeg, jpg, png, gif, webp. Хамгийн ихдээ 5MB
                    </p>
                  </div>

                  <div className="grid grid-cols-2 gap-4">
                    <div className="form-group">
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Товчны текст
                      </label>
                      <input
                        type="text"
                        className="custom-input"
                        value={formData.button_text}
                        onChange={(e) => setFormData({...formData, button_text: e.target.value})}
                        placeholder="Ачаа хайх"
                      />
                    </div>

                    <div className="form-group">
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Дараалал
                      </label>
                      <input
                        type="number"
                        className="custom-input"
                        value={formData.display_order}
                        onChange={(e) => setFormData({...formData, display_order: parseInt(e.target.value) || 0})}
                        placeholder="0"
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
                      <FaClock className="text-blue-500" />
                      Солигдох хугацаа (миллисекунд)
                    </label>
                    <input
                      type="number"
                      className="custom-input"
                      value={formData.transition_duration}
                      onChange={(e) => setFormData({...formData, transition_duration: parseInt(e.target.value) || 5000})}
                      min="1000"
                      max="60000"
                      step="1000"
                      placeholder="5000"
                    />
                    <div className="mt-2 flex flex-wrap gap-2">
                      <button
                        type="button"
                        onClick={() => setFormData({...formData, transition_duration: 3000})}
                        className="text-xs px-3 py-1 bg-blue-100 text-blue-700 rounded-full hover:bg-blue-200"
                      >
                        3 секунд
                      </button>
                      <button
                        type="button"
                        onClick={() => setFormData({...formData, transition_duration: 5000})}
                        className="text-xs px-3 py-1 bg-blue-100 text-blue-700 rounded-full hover:bg-blue-200"
                      >
                        5 секунд
                      </button>
                      <button
                        type="button"
                        onClick={() => setFormData({...formData, transition_duration: 7000})}
                        className="text-xs px-3 py-1 bg-blue-100 text-blue-700 rounded-full hover:bg-blue-200"
                      >
                        7 секунд
                      </button>
                      <button
                        type="button"
                        onClick={() => setFormData({...formData, transition_duration: 10000})}
                        className="text-xs px-3 py-1 bg-blue-100 text-blue-700 rounded-full hover:bg-blue-200"
                      >
                        10 секунд
                      </button>
                    </div>
                    <p className="text-xs text-gray-500 mt-2">
                      1000 = 1 секунд, 5000 = 5 секунд (default). Баннер автоматаар энэ хугацаанд солигдоно.
                    </p>
                  </div>

                  <div className="form-group">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Төлөв
                    </label>
                    <select
                      className="custom-input"
                      value={formData.is_active ? 'true' : 'false'}
                      onChange={(e) => setFormData({...formData, is_active: e.target.value === 'true'})}
                    >
                      <option value="true">Идэвхтэй</option>
                      <option value="false">Идэвхгүй</option>
                    </select>
                    <p className="text-xs text-gray-500 mt-1">
                      Зөвхөн идэвхтэй баннерууд нүүр хуудсанд харагдана
                    </p>
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    onClick={() => { setShowModal(false); resetForm(); }}
                    className="custom-button-secondary"
                    disabled={loading || imageUploading}
                  >
                    <FaTimes className="mr-2" />
                    Цуцлах
                  </button>
                  <button 
                    type="submit" 
                    className="custom-button-success" 
                    disabled={loading || imageUploading}
                  >
                    <FaSave className="mr-2" />
                    {loading ? 'Хадгалж байна...' : 'Хадгалах'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BannerManagement;